import { postWithFullResponse } from '@citrite/http';
import { LocationDescriptorObject } from 'history';
import { authChallengeHeader, citrixServerNameHeaderKey } from 'Environment';
import { clearSessionStorage } from 'javascript/sf/Storage';
import { workspaceLoginRoute } from 'Login';
import { PendingLogin, setPendingLogin } from 'Login/PendingLogin';
import { ListApiResult } from 'Workspace/ResourceProvider/resourceTypes';

export const loginRedirectionErrorName = 'LoginRedirectionInProgress';

export interface FetchResourceParams {
	allowUnauthenticated?: boolean;
	listUrl: string;
	location: LocationDescriptorObject;
	acceptsCachedResults?: boolean;
}

export async function fetchResources(params: FetchResourceParams) {
	const { acceptsCachedResults } = params;
	const response = await postWithFullResponse<ListApiResult>(
		params.listUrl,
		{
			resourceDetails: 'Full',
			acceptsCachedResults,
		},
		{
			passthroughDSAuthChallenge: true,
		}
	);

	let listData: ListApiResult = response.data;

	if (listData.unauthorized) {
		if (params.allowUnauthenticated) {
			return {
				resources: [],
			};
		}
		const pendingLogin: PendingLogin = {
			challenge: response.headers[authChallengeHeader],
			locationAfterLogin: params.location,
		};
		clearSessionStorage();
		setPendingLogin(pendingLogin);
		window.location.replace('#' + workspaceLoginRoute.getUrl());
		const error = new Error('Redirection to login in progress.');
		error.name = loginRedirectionErrorName;
		throw error;
	}

	listData = {
		...listData,
		serverName: response?.headers?.[citrixServerNameHeaderKey],
	};

	return listData;
}
